import React from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'

export const DashboardEconomicPerformanceChartSkeleton: React.FC = () => {
    const {t} = useTranslation()

    return (
        <DashboardCard title={t('dashboard:budget_saturation_title')}>
            <Flexbox direction="column" gap={2} fullWidth>
                {/* Main budget saturation value skeleton */}
                <Skeleton width="200px" height="32px" />

                {/* Grid with 3 metric columns */}
                <Grid gap={6} columns={3}>
                    <Flexbox direction="column" gap={2}>
                        <Skeleton width="120px" height="16px" />
                        <Skeleton width="100px" height="24px" />
                    </Flexbox>
                    <Flexbox direction="column" gap={2}>
                        <Skeleton width="120px" height="16px" />
                        <Skeleton width="100px" height="24px" />
                    </Flexbox>
                    <Flexbox direction="column" gap={2}>
                        <Skeleton width="120px" height="16px" />
                        <Skeleton width="100px" height="24px" />
                    </Flexbox>
                </Grid>

                {/* Chart section skeleton */}
                <Flexbox direction="column" gap={4} fullWidth>
                    {/* Legend skeleton */}
                    <Flexbox fullWidth justify="end">
                        <Flexbox gap={6}>
                            <Flexbox direction="row" gap={1} align="center">
                                <Skeleton width="12px" height="12px" style={{borderRadius: '50%'}} />
                                <Skeleton width="60px" height="16px" />
                            </Flexbox>
                            <Flexbox direction="row" gap={1} align="center">
                                <Skeleton width="12px" height="12px" style={{borderRadius: '50%'}} />
                                <Skeleton width="60px" height="16px" />
                            </Flexbox>
                            <Flexbox direction="row" gap={1} align="center">
                                <Skeleton width="12px" height="12px" style={{borderRadius: '50%'}} />
                                <Skeleton width="60px" height="16px" />
                            </Flexbox>
                        </Flexbox>
                    </Flexbox>

                    {/* Chart skeleton */}
                    <Skeleton width="100%" height="260px" style={{borderRadius: '8px'}} />
                </Flexbox>
            </Flexbox>
        </DashboardCard>
    )
}
